var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: _vm.headerBreadcrumbItem1.name
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.headerBreadcrumbItem1.text) + " ")]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: _vm.headerBreadcrumbItem2.name,
        params: _vm.headerBreadcrumbItem2.params
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.headerBreadcrumbItem2.text) + " ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.isReadOnly ? _vm.displayTextStaff("view_staff", "查看帳號") : _vm.isEditing ? _vm.displayTextStaff("edit_staff", "編輯帳號") : _vm.displayTextStaff("add_staff", "新增帳號")) + " ")])], 1)], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isReadOnly ? _vm.displayTextStaff("view_staff", "查看帳號") : _vm.isEditing ? _vm.displayTextStaff("edit_staff", "編輯帳號") : _vm.displayTextStaff("add_staff", "新增帳號")) + " ")]), _c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _vm.isEditing && _vm.hiddenField('branch_id') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('branch_id') + _vm.displayTextStaff('staff_belong_branch', '所屬分店'),
      "label-for": "branch_id"
    }
  }, [_vm.fromBranchPage ? _c('div', [_c('b-breadcrumb', {
    staticClass: "mb-0 p-0",
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1) : _c('div', {
    staticClass: "row"
  }, [_vm._l(_vm.staff.branches, function (branch) {
    return _c('div', {
      key: branch.id,
      staticClass: "col-8"
    }, [_c('b-breadcrumb', {
      staticClass: "mb-0 p-0",
      attrs: {
        "items": _vm.getBranchBreadcrumb(branch)
      }
    })], 1);
  }), _c('div', {
    staticClass: "col-4"
  }, [_vm.checkPermission([_vm.consts.STAFF_BRANCH_MODIFY]) && !_vm.isReadOnly ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.goToEditStaffBranch
    }
  }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_set_branch_action", "編輯所屬分店")) + " ")]) : _vm._e()], 1)], 2), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.branch_id.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_is_required", "此欄位為必填")) + " ")])], 1) : _vm._e(), !_vm.isEditing && !_vm.isReadOnly && _vm.hiddenField('branch_id') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('branch_id') + _vm.displayTextStaff('staff_belong_branch', '所屬分店')
    }
  }, [_c('AppSingleSelect', {
    staticClass: "mr-1",
    attrs: {
      "options": _vm.branchOptions,
      "disabled": _vm.fromBranchPage || _vm.isReadOnly
    },
    on: {
      "input": _vm.branchChange
    },
    model: {
      value: _vm.selectedBranch,
      callback: function callback($$v) {
        _vm.selectedBranch = $$v;
      },
      expression: "selectedBranch"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.branch_id.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_is_required", "此欄位為必填")) + " ")])], 1) : _vm._e(), _vm.fromBranchPage ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayTextStaff('staff.branch_sort', '店內順序')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "number",
      "min": "1",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.staff.branch_order,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "branch_order", $$v);
      },
      expression: "staff.branch_order"
    }
  })], 1) : _vm._e(), _vm.hiddenField('role_code') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": '*' + _vm.displayTextStaff('staff_role', '員工角色')
    }
  }, [_c('b-form-select', {
    staticClass: "mr-3",
    attrs: {
      "state": _vm.v$.staff.role_code.$error ? false : null,
      "options": _vm.roleOptions,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.staff.role_code,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "role_code", $$v);
      },
      expression: "staff.role_code"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.role_code.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_is_required", "此欄位為必填")) + " ")])], 1) : _vm._e(), _vm.hiddenField('employee_code') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": '*' + _vm.displayTextStaff('staff_code', '員工編號')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.staff.employee_code.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.staff.employee_code,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "employee_code", $$v);
      },
      expression: "staff.employee_code"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.employee_code.$error
    }
  }, [_vm._v(" 此欄位為必填，且只能是英文、數字、-、_、. 、+、@ ")])], 1) : _vm._e(), _vm.hiddenField('name') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": '*' + _vm.displayRequireSign('name') + _vm.displayTextStaff('staff_name', '員工姓名'),
      "label-for": "input-1"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "input-1",
      "type": "text",
      "state": _vm.v$.staff.name.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.staff.name,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "name", $$v);
      },
      expression: "staff.name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.name.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_is_required", "此欄位為必填")) + " ")])], 1) : _vm._e(), _vm.hiddenField('avatar') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('avatar') + _vm.displayTextStaff('staff_avatar', '個人頭像'),
      "label-for": "input-1"
    }
  }, [_vm.image || _vm.staff.avatar_url ? _c('li', {
    staticClass: "s-image-list-item s-draggable"
  }, [_c('img', {
    staticClass: "s-cropped-image",
    attrs: {
      "src": _vm.image || _vm.staff.avatar_url
    }
  }), _c('button', {
    staticClass: "btn btn-danger s-delete-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.deleteImage();
      }
    }
  }, [_vm._v(" Ｘ ")])]) : _c('li', {
    staticClass: "s-image-list-item"
  }, [_c('ImageSelector', {
    on: {
      "input": _vm.selectImage
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn(_ref) {
        var openFileSelector = _ref.openFileSelector;
        return [_c('button', {
          staticClass: "btn s-trigger-btn",
          on: {
            "click": openFileSelector
          }
        }, [_vm._v(" ＋ 加入照片 ")])];
      }
    }], null, false, 832809640)
  })], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.avatar.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_is_required", "此欄位為必填")) + " ")])], 1) : _vm._e(), _vm.hiddenField('email') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('email') + _vm.displayTextStaff('email', 'Email')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.staff.email.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.staff.email,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "email", $$v);
      },
      expression: "staff.email"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.email.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_is_required", "此欄位為必填")) + " ")])], 1) : _vm._e(), _vm.hiddenField('mobile_phone') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('mobile_phone') + _vm.displayTextStaff('mobile', '手機')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.staff.mobile_phone.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.staff.mobile_phone,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "mobile_phone", $$v);
      },
      expression: "staff.mobile_phone"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.mobile_phone.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_is_required", "此欄位為必填")) + " ")])], 1) : _vm._e(), _c('FormField', {
    attrs: {
      "setting": _vm.formSetting('job_level'),
      "formLabel": _vm.displayRequireSign('job_level') + _vm.displayTextStaff('staff_job_level', '職稱'),
      "isError": _vm.v$.staff.job_level.$error,
      "errorMessage": _vm.displayTextStaff('staff_is_required', '此欄位為必填'),
      "isReadOnly": _vm.isReadOnly,
      "isShow": _vm.hiddenField('job_level')
    },
    model: {
      value: _vm.staff.job_level,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "job_level", $$v);
      },
      expression: "staff.job_level"
    }
  }), _vm.hiddenField('service_unit') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('service_unit') + _vm.displayTextStaff('staff_service_unit', '服務單位')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.staff.service_unit.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.staff.service_unit,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "service_unit", $$v);
      },
      expression: "staff.service_unit"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.service_unit.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_is_required", "此欄位為必填")) + " ")])], 1) : _vm._e(), _c('FormField', {
    attrs: {
      "setting": _vm.formSetting('dept_name'),
      "formLabel": _vm.displayRequireSign('dept_name') + _vm.displayTextStaff('staff_dept', '部門'),
      "isError": _vm.v$.staff.dept_name.$error,
      "errorMessage": _vm.displayTextStaff('staff_is_required', '此欄位為必填'),
      "isReadOnly": _vm.isReadOnly,
      "isShow": _vm.hiddenField('dept_name')
    },
    model: {
      value: _vm.staff.dept_name,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "dept_name", $$v);
      },
      expression: "staff.dept_name"
    }
  }), _vm.hiddenField('description') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('description') + _vm.displayTextStaff('staff_description', '描述')
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.staff.description.$error ? false : null,
      "readonly": _vm.isReadOnly,
      "row": "3"
    },
    model: {
      value: _vm.staff.description,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "description", $$v);
      },
      expression: "staff.description"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.description.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_is_required", "此欄位為必填")) + " ")])], 1) : _vm._e(), _vm.hiddenField('office_phone_area') || _vm.hiddenField('office_phone') || _vm.hiddenField('office_phone_ext') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('office_phone') + _vm.displayTextStaff('staff_phone', '市話')
    }
  }, [_c('div', {
    staticClass: "d-flex w-100 city-selector-set-has-value"
  }, [_c('b-input-group', {
    staticClass: "col-3 px-0",
    attrs: {
      "prepend": "(",
      "append": ")"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mb-sm-0",
    attrs: {
      "type": "text",
      "disabled": _vm.isReadOnly,
      "placeholder": "區碼"
    },
    model: {
      value: _vm.staff.office_phone_area,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "office_phone_area", $$v);
      },
      expression: "staff.office_phone_area"
    }
  })], 1), _c('b-input-group', {
    staticClass: "col-8 px-0",
    attrs: {
      "append": "#"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mb-sm-0",
    attrs: {
      "type": "text",
      "disabled": _vm.isReadOnly,
      "placeholder": "市話"
    },
    model: {
      value: _vm.staff.office_phone,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "office_phone", $$v);
      },
      expression: "staff.office_phone"
    }
  })], 1), _c('b-form-input', {
    staticClass: "mb-2 mb-sm-0 col-1",
    attrs: {
      "type": "text",
      "disabled": _vm.isReadOnly,
      "placeholder": "分機"
    },
    model: {
      value: _vm.staff.office_phone_ext,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "office_phone_ext", $$v);
      },
      expression: "staff.office_phone_ext"
    }
  })], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.office_phone_area.$error && !_vm.v$.staff.office_phone.$error && !_vm.v$.staff.office_phone_ext.$error
    }
  }, [_vm._v(" 此欄位為必須為數字 ")])], 1) : _vm._e(), _vm.hiddenField('is_enabled') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('is_enabled') + _vm.displayTextStaff('is_enabled', '是否啟用')
    }
  }, [_c('b-form-checkbox', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": _vm.isReadOnly,
      "state": _vm.v$.staff.is_enabled.$error ? false : null
    },
    model: {
      value: _vm.staff.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "is_enabled", $$v);
      },
      expression: "staff.is_enabled"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.is_enabled.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_is_required", "此欄位為必填")) + " ")])], 1) : _vm._e(), (_vm.isEditing || _vm.isReadOnly) && _vm.hiddenField('login_at') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayTextStaff('staff_login_at', '最後登入時間')
    }
  }, [_c('div', {
    staticClass: "h-100 d-flex align-items-center"
  }, [_vm._v(" " + _vm._s(_vm.staff.login_at || '-') + " ")])]) : _vm._e(), (_vm.isEditing || _vm.isReadOnly) && _vm.hiddenField('last_failed_login_at') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayTextStaff('staff_last_failed_login_at', '最後登入失敗時間')
    }
  }, [_c('div', {
    staticClass: "h-100 d-flex align-items-center"
  }, [_vm._v(" " + _vm._s(_vm.staff.last_failed_login_at || '-') + " ")])]) : _vm._e(), (_vm.isEditing || _vm.isReadOnly) && _vm.hiddenField('login_failed_count') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayTextStaff('staff_login_failed_count', '連續登入失敗次數')
    }
  }, [_c('div', {
    staticClass: "h-100 d-flex align-items-center"
  }, [_vm._v(" " + _vm._s(_vm.staff.login_failed_count || 0) + " "), _vm.isEditing || _vm.isReadOnly ? _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "size": "sm",
      "variant": "outline-primary",
      "disabled": _vm.isUnlockButtonDisabled
    },
    on: {
      "click": _vm.handleUnlock
    }
  }, [_vm._v(" " + _vm._s(_vm.staff.is_locked ? "解鎖" : "次數重置") + " ")]) : _vm._e()], 1)]) : _vm._e(), _vm.hiddenField('left_at') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('left_at') + _vm.displayTextStaff('staff_leave_date', '離職日')
    }
  }, [_c('datepicker', {
    attrs: {
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isReadOnly,
      "clear-button": true
    },
    model: {
      value: _vm.staff.left_at,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "left_at", $$v);
      },
      expression: "staff.left_at"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.left_at.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_is_required", "此欄位為必填")) + " ")])], 1) : _vm._e(), _vm.hiddenField('line_id') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('line_id') + _vm.displayTextStaff('line_uid', 'LINE UID')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly,
      "state": _vm.v$.staff.line_id.$error ? false : null
    },
    model: {
      value: _vm.staff.line_id,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "line_id", $$v);
      },
      expression: "staff.line_id"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.line_id.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_is_required", "此欄位為必填")) + " ")])], 1) : _vm._e(), _vm.hiddenField('line_contact_url') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayRequireSign('line_contact_url') + _vm.displayTextStaff('staff_line_url', 'Line 連結網址')
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.staff.line_contact_url.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.staff.line_contact_url,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "line_contact_url", $$v);
      },
      expression: "staff.line_contact_url"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.line_contact_url.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayTextStaff("staff_is_required", "此欄位為必填")) + " ")])], 1) : _vm._e(), !_vm.isEditing && _vm.hiddenField('password') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": _vm.displayTextStaff('staff_generator_password', '自動產生密碼')
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.generatorPassword,
      callback: function callback($$v) {
        _vm.generatorPassword = $$v;
      },
      expression: "generatorPassword"
    }
  })], 1) : _vm._e(), !_vm.isEditing && _vm.hiddenField('password') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" *" + _vm._s(_vm.displayTextStaff('staff_password', '密碼')) + " "), _c('i', {
          staticClass: "fa fa-question-circle ml-2 text-muted",
          staticStyle: {
            "font-size": "1rem"
          },
          attrs: {
            "id": "password-tip-tooltip"
          }
        }), _c('b-tooltip', {
          attrs: {
            "target": "password-tip-tooltip",
            "triggers": "hover",
            "placement": "right"
          }
        }, [_vm._v(" 密碼至少 8 碼，且需同時包含大寫字母、小寫字母、數字及至少 1 個特殊符號 ")])];
      },
      proxy: true
    }], null, false, 1356578740)
  }, [_c('b-input-group', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0"
  }, [_c('b-form-input', {
    attrs: {
      "type": _vm.showPassword ? 'text' : 'password',
      "state": _vm.v$.staff.password.$error ? false : null,
      "placeholder": "密碼至少 8 碼，且需同時包含大寫字母、小寫字母、數字及至少 1 個特殊符號"
    },
    model: {
      value: _vm.staff.password,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "password", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "staff.password"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function click($event) {
        _vm.showPassword = !_vm.showPassword;
      }
    }
  }, [_c('i', {
    class: ['mx-auto', _vm.showPassword ? 'fa fa-eye' : 'fa fa-eye-slash']
  })])], 1)], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.password.$error
    }
  }, [_vm.v$.staff.password.required && _vm.v$.staff.password.required.$invalid ? [_vm._v(" 此欄位為必填 ")] : _vm.v$.staff.password.minLength && _vm.v$.staff.password.minLength.$invalid ? [_vm._v(" 密碼最少要 8 位數 ")] : _vm.v$.staff.password.passwordComplexity && _vm.v$.staff.password.passwordComplexity.$invalid ? [_vm._v(" 密碼至少 8 碼，且需同時包含大寫字母、小寫字母、數字及至少 1 個特殊符號 ")] : _vm._e()], 2)], 1) : _vm._e(), !_vm.isEditing && _vm.hiddenField('password') ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": '*' + _vm.displayTextStaff('staff_password_confirm', '確認密碼')
    }
  }, [_c('b-input-group', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0"
  }, [_c('b-form-input', {
    attrs: {
      "type": _vm.showPasswordConfirm ? 'text' : 'password',
      "state": _vm.v$.staff.password_confirmation.$error ? false : null,
      "placeholder": "密碼至少 8 碼，且需同時包含大寫字母、小寫字母、數字及至少 1 個特殊符號"
    },
    model: {
      value: _vm.staff.password_confirmation,
      callback: function callback($$v) {
        _vm.$set(_vm.staff, "password_confirmation", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "staff.password_confirmation"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    staticClass: "mx-auto",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function click($event) {
        _vm.showPasswordConfirm = !_vm.showPasswordConfirm;
      }
    }
  }, [_c('i', {
    class: ['mx-auto', _vm.showPasswordConfirm ? 'fa fa-eye' : 'fa fa-eye-slash']
  })])], 1)], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.staff.password_confirmation.$error
    }
  }, [_vm._v(" 需與密碼相同 ")])], 1) : _vm._e()], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("返回 ")]), !_vm.isReadOnly ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("儲存")]) : _vm._e()], 1)])], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }